import(/* webpackMode: "eager" */ "/home/interim/frontend/app/support/page.tsx");
